import type { StateCreator } from "zustand";
import { immer } from "zustand/middleware/immer";

interface TelemetryData {
  connectionQualitySeries: Array<{
    timestamp: number;
    value: number;
  }>;
}

interface TelemetryActions {
  addConnectionQualityData: (value: number) => void;
  clearData: () => void;
}

export interface TelemetrySlice {
  telemetry: {
    data: TelemetryData;
    actions: TelemetryActions;
  };
}

const initialTelemetryData: TelemetryData = {
  connectionQualitySeries: [],
};

export const createTelemetrySlice: StateCreator<
  TelemetrySlice,
  [],
  [["zustand/immer", never]],
  TelemetrySlice
> = immer(set => ({
  telemetry: {
    data: initialTelemetryData,
    actions: {
      clearData: () => {
        set(state => {
          state.telemetry.data = { ...initialTelemetryData };
        });
      },
      addConnectionQualityData: (value: number) => {
        set(state => {
          state.telemetry.data.connectionQualitySeries.push({
            timestamp: Date.now(),
            value,
          });
        });
      },
    },
  },
}));
